export const AGENT_CONSTS = {
    GET_AGENTS_LIST: 'GET_AGENTS_LIST',
    GET_TEMPLATES_AGENT: 'GET_TEMPLATES_AGENT',
    UPDATE_LANGUAGE: "UPDATE_LANGUAGE"
};
